import Request from 'admin/lib/adminRequest';

export default {
    list: async ({ query, id, pagination }) => {
        const { page, pageSize: limit } = pagination;
        let selectedIds = [];
        if (id !== undefined) {
            selectedIds = Array.isArray(id) ? id : [id];
        }

        try {
            const [rulesRes, selectedRes] = await Promise.all([
                Request.postJSON('admin/project/listRules', {
                    query,
                    limit,
                    page,
                    type: JSON.stringify(['independent'])
                }),
                Request.postJSON('admin/project/listRules', {
                    id: selectedIds,
                    type: JSON.stringify(['independent'])
                })
            ]);

            if (rulesRes.error || selectedRes.error) {
                throw new Error(rulesRes.msg || selectedRes.msg);
            }

            const rules = { data: rulesRes.data, count: rulesRes.count };
            const selected = { data: selectedRes.data };

            selected.data.forEach(itemSelected => {
                const item = rules.data.find(
                    itemRule => itemRule.id === itemSelected.id
                );
                if (!item) {
                    rules.data.push({
                        ...itemSelected,
                        missingSelected: true
                    });
                }
            });

            return rules;
        } catch (err) {
            console.error(err);
        }
    },
    listRuleType: () => {
        const ruleType = [
            { id: 'blueprint', name: _('Blueprint') },
            { id: 'dashboard', name: _('Dashboard') },
            { id: 'event', name: _('Event') },
            { id: 'form', name: _('Form') },
            { id: 'independent', name: _('Independent') },
            { id: 'pipeline', name: _('Job Pipeline') },
            { id: 'report', name: _('Report') },
            { id: 'webservice', name: _('Webservice') },
            { id: 'workflow', name: _('Workflow') }
        ];

        return {
            data: ruleType,
            count: ruleType.length
        };
    },
    getRule: async id => {
        try {
            const result = await Request.postJSON('admin/project/getRule', {
                id
            });

            if (result.error) {
                throw new Error(result.msg);
            }

            return result.data;
        } catch (err) {
            console.error(err);
        }
    }
};
